import type { RightPanelOpenRequestDetail } from './types/right-panel-open-request-detail'
import type { RightPanelCloseRequestDetail } from './types/right-panel-close-request-detail'
/**
 * Window event asking `RightPanel` to open (or switch to) one of its panels — lets code outside
 * the panel tree, such as the canvas context menu, drive it the same way the rail icons do.
 * Mirrors the existing window-event bridges (`left-panel-opened`, `select-tool-activated`).
 */
export const RIGHT_PANEL_OPEN_REQUEST_EVENT = 'right-panel-open-request'

/** `RightPanel`'s own panel ids — note the Backgrounds id carries a trailing space. The full set
 *  lives in `right-panel/root-panel/constants/panel-ids.ts`. */
export const BACKGROUNDS_RIGHT_PANEL_ID = 'backgrounds '

/** The Templates panel's id; it also carries a trailing space. */
export const TEMPLATES_RIGHT_PANEL_ID = 'templates '

export function requestRightPanelOpen(panel: string): void {
  window.dispatchEvent(
    new CustomEvent<RightPanelOpenRequestDetail>(RIGHT_PANEL_OPEN_REQUEST_EVENT, {
      detail: { panel },
    })
  )
}

/**
 * Window event asking `RightPanel` to close. With a `panel` id it closes only if that panel is the
 * one currently showing, and any other open panel is left alone. With no id it closes whichever
 * panel is showing — the menu bar's Previous/Next spread buttons do this, since an open panel
 * belongs to the spread being left (WMPCM-11050 AC-6).
 */
export const RIGHT_PANEL_CLOSE_REQUEST_EVENT = 'right-panel-close-request'

export function requestRightPanelClose(panel?: string): void {
  window.dispatchEvent(
    new CustomEvent<RightPanelCloseRequestDetail>(RIGHT_PANEL_CLOSE_REQUEST_EVENT, {
      detail: { panel },
    })
  )
}
